import { Icon } from "../../../../components";

export const DiscoverySuggestionTag = ({
  tag,
  onClick,
}: {
  tag: string;
  onClick?: () => void;
}) => {
  return (
    <div
      key={tag}
      className={
        "flex cursor-pointer items-center gap-2 rounded-full border border-solid border-gray-300 bg-white px-3 py-2 transition-colors hover:bg-gray-100"
      }
      onClick={onClick}
    >
      {tag} <Icon icon={"ARROW_TOP_RIGHT"} />
    </div>
  );
};
